import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/brand/Logo';
import styles from './ConfigErrorPage.module.css';

export function ConfigErrorPage() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <Logo size="md" />
      <h1>{t('errors.configTitle')}</h1>
      <p>{t('errors.configBody')}</p>
      <Link to="/">{t('common.back')}</Link>
    </div>
  );
}
